var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    { attrs: { value: _vm.value, width: "800", persistent: "" } },
    [
      _c(
        "v-card",
        { attrs: { color: "fill" } },
        [
          _c(
            "v-card-title",
            { class: _vm.title },
            [
              _c("span", [_vm._v("Mass Copy Ad Features")]),
              _c(
                "v-col",
                {
                  staticClass: "ml-auto my-auto pa-0",
                  attrs: { cols: "auto" },
                },
                [
                  _c("span", { staticClass: "text-body-1" }, [
                    _vm._v(
                      " Selected Features: (" +
                        _vm._s(_vm.featureIds.length) +
                        ") "
                    ),
                  ]),
                ]
              ),
            ],
            1
          ),
          _c(
            "v-container",
            { staticClass: "ma-0 pa-0 pt-4", attrs: { fluid: "" } },
            [
              _c("v-data-table", {
                attrs: {
                  headers: _vm.headers,
                  items: _vm.uniqueAds,
                  loading: _vm.loading,
                  dense: "",
                  height: "384px",
                  "show-select": "",
                  "fixed-header": "",
                  "footer-props": { "items-per-page-options": [-1] },
                  "items-per-page": -1,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: `item.start_date`,
                      fn: function ({ item }) {
                        return [
                          item.start_date
                            ? _c("span", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$dateConfig.formatDate(
                                        item.start_date
                                      )
                                    )
                                ),
                              ])
                            : _c("span", [_vm._v("-")]),
                        ]
                      },
                    },
                    {
                      key: `item.end_date`,
                      fn: function ({ item }) {
                        return [
                          item.end_date
                            ? _c("span", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$dateConfig.formatDate(item.end_date)
                                    )
                                ),
                              ])
                            : _c("span", [_vm._v("-")]),
                        ]
                      },
                    },
                  ],
                  null,
                  true
                ),
                model: {
                  value: _vm.selectedAds,
                  callback: function ($$v) {
                    _vm.selectedAds = $$v
                  },
                  expression: "selectedAds",
                },
              }),
              _c("v-divider"),
            ],
            1
          ),
          _c(
            "v-toolbar",
            { attrs: { flat: "", color: "fill" } },
            [
              _c("v-col", { attrs: { cols: "auto" } }, [
                _vm.noValidAds
                  ? _c(
                      "span",
                      { staticClass: "warning--text" },
                      [
                        _c("v-icon", { attrs: { color: "warning" } }, [
                          _vm._v("mdi-alert-circle-outline"),
                        ]),
                        _vm._v(" No valid feature destinations found "),
                      ],
                      1
                    )
                  : _c("span", [
                      _vm._v(
                        " Selected Ads: (" +
                          _vm._s(_vm.selectedAds.length) +
                          ") "
                      ),
                    ]),
              ]),
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  class: _vm.body,
                  attrs: { text: "" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("update:value", false)
                    },
                  },
                },
                [_vm._v(" Cancel ")]
              ),
              _c(
                "v-btn",
                {
                  staticClass: "white--text ml-2",
                  class: _vm.body,
                  attrs: {
                    disabled: _vm.copyDisabled,
                    loading: _vm.copyInProgress,
                    color: "warning",
                  },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.openConfirmDialog.apply(null, arguments)
                    },
                  },
                },
                [_vm._v(" Copy ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.warningsModal
        ? _c("FeaturePromoWarnings", {
            attrs: {
              multiple: "",
              selectedAd: _vm.selectedAd,
              gappedPromos: _vm.gappedPromos,
              move: false,
            },
            on: {
              cancel: _vm.closeWarningsModal,
              confirmAction: _vm.confirmAction,
            },
            model: {
              value: _vm.warningsModal,
              callback: function ($$v) {
                _vm.warningsModal = $$v
              },
              expression: "warningsModal",
            },
          })
        : _vm._e(),
      _vm.confirmDialog
        ? _c("MassCopyConfirm", {
            on: {
              cancel: _vm.closeConfirmDialog,
              confirmAction: _vm.confirmAction,
            },
            model: {
              value: _vm.confirmDialog,
              callback: function ($$v) {
                _vm.confirmDialog = $$v
              },
              expression: "confirmDialog",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }